import * as Sentry from "@sentry/browser";
import mixpanel from "mixpanel-browser";

import { enableSentry } from "@formant/core/common/config";
import { isGdprRegion } from "@formant/core/common/isGdprRegion";
import { logger } from "@formant/core/common/logger";
import { IOrganization } from "@formant/core/model/IOrganization";
import { IUser } from "@formant/core/model/IUser";

import { mixpanelToken } from "../config";
import { headless } from "./isHeadless";

export function identify(user: IUser, organization: IOrganization) {
    const {
        id: userId,
        organizationId,
        email,
        firstName,
        lastName,
        region,
    } = user;

    logger.info("Identified", { userId, email });

    if (headless) {
        return;
    }

    if (enableSentry) {
        const sentryUserScope = !isGdprRegion(region)
            ? { userId, email, organizationId }
            : { userId, organizationId };
        Sentry.configureScope(scope => scope.setUser(sentryUserScope));
    }

    if (mixpanelToken) {
        // Identify by user id so Mixpanel's user metrics (WAU, retention, funnels) count people, not organizations (the Jul 2026 org-keyed identity collapsed every org to one "user"). Org stays attached as a group for per-customer breakdowns; MTU is held down by the dev/stage kill and the event allowlist instead.
        const mixpanelUser = !isGdprRegion(region)
            ? {
                  $email: email,
                  $first_name: firstName,
                  $last_name: lastName,
                  organization_id: organizationId,
                  $plan: organization.plan,
                  $hubspotId: organization.hubspotId,
              }
            : {
                  organization_id: organizationId,
                  $plan: organization.plan,
                  $hubspotId: organization.hubspotId,
              };
        mixpanel.identify(userId);
        mixpanel.people.set(mixpanelUser);
        (mixpanel as any).set_group("Organization ID", organizationId);
        (mixpanel as any).set_group("Organization", organization.name);
    }
}
